import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Send, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });

export const ReportPanel = ({ clientId }) => {
  const [r, setR] = useState(null);
  const [preview, setPreview] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/clients/${clientId}/report`).then((res) => setR(res.data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);
  if (!r) return null;
  const toggle = async (v) => {
    await api.put(`/clients/${clientId}/report`, { monthly_report: v });
    setR({ ...r, monthly_report: v });
    toast.success(v ? "Report mensile attivato" : "Report mensile disattivato");
  };
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/clients/${clientId}/report/send`);
      toast.success(`Report inviato a ${data.email}`);
      load();
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="panel space-y-4 p-6" data-testid="client-report-panel">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-1.5 eyebrow"><Mail className="h-3.5 w-3.5" />Report mensile</span>
        <Switch checked={r.monthly_report} onCheckedChange={toggle} data-testid="client-report-toggle" />
      </div>
      <p className="text-xs leading-relaxed text-zinc-500">
        {r.email ? <>Il 1° di ogni mese alle 9:00 invia a <span className="text-zinc-800">{r.email}</span> visite e scansioni del mese precedente.</> : "Aggiungi un'email nella scheda del cliente per inviare il report."}
      </p>
      <div className="text-xs text-zinc-500" data-testid="client-report-last">{r.last ? `Ultimo invio: ${fmt(r.last.sent_at)} (${r.last.month})` : "Nessun report ancora inviato"}</div>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" onClick={() => setPreview(true)} data-testid="client-report-preview"><Eye className="mr-1.5 h-4 w-4" />Anteprima</Button>
        <Button variant="outline" size="sm" onClick={send} disabled={busy || !r.email} data-testid="client-report-send"><Send className="mr-1.5 h-4 w-4" />{busy ? "Invio…" : "Invia ora"}</Button>
      </div>
      <Dialog open={preview} onOpenChange={setPreview}>
        <DialogContent className="sm:max-w-2xl" data-testid="client-report-preview-dialog">
          <DialogHeader><DialogTitle>{r.subject}</DialogTitle></DialogHeader>
          <iframe title="Anteprima report" srcDoc={r.html} sandbox="" tabIndex={-1} className="h-[60vh] w-full rounded-xl border" data-testid="client-report-iframe" />
        </DialogContent>
      </Dialog>
    </section>
  );
};
